<template>
  <zt-modal
    :active="activeModal"
    :title="$t('message.downloadBackup.downloadModal.title')"
    @close="closeDownloadDialog"
    max-width="600px"
  >
    <div class="flex flex-col items-center justify-center py-24">
      <template v-if="isLinkActive">
        <div>
          <DownloadOkSVG />
        </div>
        <div class="pt-4 text-center text-zt-lg">
          <p>{{$t('message.downloadBackup.downloadModal.messageInitialDownload')}}</p>
          <div>
            <p>{{$t('message.downloadBackup.downloadModal.problemWithDownloadLink')}}</p>
            <button data-vs-button="download-zip" class="font-bold underline" @click="downloadZip">
              {{$t('message.downloadBackup.downloadModal.clickHere')}}
            </button>
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <DownloadExpiredSVG />
        </div>
        <div class="pt-4 text-center text-zt-lg" v-if="isErrorMFA">
          <p>{{$t('message.downloadBackup.downloadModal.mfaError')}}</p>
        </div>
        <div class="pt-4 text-center text-zt-lg" v-else>
          <p>{{$t('message.downloadBackup.downloadModal.expiredDownload')}}</p>
          <div>
            <p>{{$t('message.downloadBackup.downloadModal.retryDownload')}}</p>
            <button data-vs-button="send-docs" class="font-bold underline" @click="sendToDocuments">
              {{$t('message.downloadBackup.downloadModal.clickHere')}}
            </button>
          </div>
        </div>
      </template>
    </div>
    <template #modal-footer>
      <div class="flex justify-end p-4 bg-zt-dark-100">
        <zt-button data-vs-button="understood" @click="closeDownloadDialog">
          {{$t('message.downloadBackup.understood')}}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>

<script>
import User from '@/apiClient/User'
import {mapActions} from "vuex";
import DownloadOkSVG from "@/components/menu/header-top/download-backup/SVG/DownloadOkSVG";
import DownloadExpiredSVG from "@/components/menu/header-top/download-backup/SVG/DownloadExpiredSVG";

const handleData = async data => {
  const element = document.createElement('a')
  element.href = `${data}`
  element.click()
}

export default {
  name: "downloadModal",
  inject: ['closeDownloadDialog'],
  components: {
    DownloadOkSVG,
    DownloadExpiredSVG
  },
  props: ['activeModal', 'fileLink', 'expiredStatus', 'closeModal', 'mfaStatus'],
  data() {
    return {
      userInstance: new User()
    }
  },
  computed: {
    isLinkActive() {
      return !this.expiredStatus
    },
    isErrorMFA() {
      return this.mfaStatus && this.expiredStatus
    },
  },
  methods: {
    ...mapActions({
      setParamLoginFactory: 'setParamLoginFactory'
    }),
    sendToDocuments() {
      this.$router.push({name: 'documentSearch'})
      this.setParamLoginFactory('')
      this.closeDownloadDialog()
    },
    sendToMfa() {
      this.$router.push({name: 'documentSearch'})
      this.setParamLoginFactory('')
      this.closeDownloadDialog()
    },
    downloadZip() {
      handleData(this.fileLink)
    }
  },
  watch: {
    fileLink(newValue) {
      if(newValue) this.downloadZip()
    }
  }
}
</script>

<style scoped>

</style>
